import { TICKET_STATE_LABELS } from '../../lib/work-management-helpers';
import { TicketCard } from './TicketCard';
import type { Ticket, TicketState } from '@localagent/sdk';

interface BoardColumnProps {
  state: TicketState;
  tickets: Ticket[];
}

export function BoardColumn({ state, tickets }: BoardColumnProps) {
  return (
    <div className="flex-shrink-0 w-64">
      <div className="h-full rounded-lg bg-card transition-colors">
        <div className="p-3">
          <div className="flex items-center justify-between">
            <h3 className="text-sm font-semibold">{TICKET_STATE_LABELS[state]}</h3>
            <span className="text-xs text-muted-foreground">{tickets.length}</span>
          </div>
        </div>
        <div className="p-2 space-y-2 min-h-[200px]">
          {tickets.map((ticket) => (
            <TicketCard key={ticket.id} ticket={ticket} />
          ))}
        </div>
      </div>
    </div>
  );
}
